import Button from "@client/controls/Button/component";
import Modal from "@client/controls/Modal/container";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";

export interface DeleteModalMapProps {
  className?: string;
  isAdmin?: boolean;
  isCentered?: boolean;
  isLoading?: boolean;
  isVisible: boolean;
  title: string;
  message: string;
}

export interface DeleteModalActionProps {
  onClose?: () => void;
  onDelete: () => void;
}

export type DeleteModalProps = DeleteModalActionProps & DeleteModalMapProps;

const DeleteModal = ({ isCentered = true, message, title, onDelete, ...props }: DeleteModalProps) => {
  const i18n = useI18n();

  return (
    <Modal
      {...props}
      className={classNames(props.className, { "admin _theme_": props.isAdmin })}
      isCentered={isCentered}
      isTopMost
    >
      <Modal.Header title={title} />
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-light" onClick={props.onClose}>
          {i18n.cancel}
        </Button>
        <Button className="btn-danger" onClick={onDelete}>
          {i18n.delete}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
